import InputField from "../../InputField/InputField";
import { HeadingTitle } from "../ModalContainer";
import { toast } from "react-toastify";
import { useState } from "react";
import axios from "axios";
import Loader from "../../Loading/Loading";
import { BASEURI } from "../../../Middleware/axiosInstance";
import secureLocalStorage from "react-secure-storage";

const RequestApproval = ({ title, close, order_id, cut_id, fetchData }) => {
  const [weight, setWeight] = useState("");
  const [loading, setLoading] = useState(false);

  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (weight === "") {
        toast.error("Please enter the weight of one layer.");
        return;
      }
      const { data } = await axios.post(`${BASEURI}`, {
        service_name: "manufacture_order_cut_fabric_estimation_save",
        token: token,
        manufacture_order_id: order_id,
        manufacture_order_cut_id: cut_id,
        data: {
          weight_of_one_layer: weight,
        },
      });

      if (data.status === 1) {
        toast.success("Submitted Successfully");
        fetchData();
      } else {
        toast.error(data?.msg);
      }
      setLoading(false);
      close();
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <div>
      <HeadingTitle title={title} center={false} closeModal={close} />
      <div className="mtx2-3">
        <div>
          <InputField
            label={"Weight of one layer"}
            placeholder={"Enter weight"}
            onChange={(value) => setWeight(value)}
          />
        </div>
      </div>
      <div className="mt-3 text-center">
        <button
          className="add-btn"
          onClick={handleSubmit}
          style={{ backgroundColor: "#3C94C6" }}
        >
          {loading ? <Loader color={"#ffffff"} size={18} /> : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default RequestApproval;
